export default __webpack_public_path__ + "static/media/Doctor_Icon.7ddbea89.jpg";